import { ApiHelper } from "../ApiHelper";
import type { RegressionDiagnosis } from "../interfaces/RegressionDiagnosis";

// Returns the AI regression diagnosis for a commit, or null when none has been generated yet.
// The backend returns an empty body (or a plain string) when there is no diagnosis.
export async function getRegressionDiagnosis(
  serviceName: string,
  commitId: string,
): Promise<RegressionDiagnosis | null> {
  const url = `/api/service/${serviceName}/commits/${commitId}/regressiondiagnosis`;
  const result = await ApiHelper(url);

  if (result && typeof result === "object" && "status" in result) {
    return result as RegressionDiagnosis;
  }
  return null;
}

export async function createRegressionDiagnosisWorkItem(
  serviceName: string,
  commitId: string,
): Promise<RegressionDiagnosis> {
  const url = `/api/service/${serviceName}/commits/${commitId}/regressiondiagnosis/workitem`;
  const result = await ApiHelper(url, "POST");

  if (result && typeof result === "object" && "status" in result) {
    return result as RegressionDiagnosis;
  }
  throw new Error("Work-item creation returned an invalid response.");
}
